import { render, staticRenderFns } from "./roomDetail.vue?vue&type=template&id=3d14f8d4&scoped=true&"
import script from "./roomDetail.vue?vue&type=script&lang=js&"
export * from "./roomDetail.vue?vue&type=script&lang=js&"
import style0 from "./roomDetail.vue?vue&type=style&index=0&id=3d14f8d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d14f8d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VDivider,VForm,VSelect,VTextField})
